import PAGE_TYPES from 'bundles/unified-description-page-common/constants/pageTypes';

import _t from 'i18n!nls/xdp';

export const getSkillsTitle = (pageType?: typeof PAGE_TYPES[keyof typeof PAGE_TYPES]) => {
  if (pageType === PAGE_TYPES.PORTFOLIO_PROJECT) {
    return _t("Skills you'll demonstrate");
  } else {
    return _t("Skills you'll practice");
  }
};

export const getDescriptionTitle = (pageType?: typeof PAGE_TYPES[keyof typeof PAGE_TYPES]) => {
  if (pageType === PAGE_TYPES.PORTFOLIO_PROJECT) {
    return _t('Objectives');
  }

  return undefined;
};
